/**
 * Returns the projectVersionId for a version, creating the row if needed.
 *
 * bsaProjectVersions rows are created lazily on the first human action, and
 * setting a bug or CVE state requires one. Overriding an auto-mark on a
 * version nobody has touched is that first human action, so creating the row
 * then is correct — it keeps "a row exists" meaning "a human acted".
 *
 * `setVersionState` is injected so this is testable without the API client.
 */
export async function ensureVersionRow({ project, version, userVersionData, setVersionState }) {
  if (userVersionData && userVersionData.id) return userVersionData.id;

  const response = await setVersionState({
    projectId: project.id,
    versionId: version.suggestionId,
    productName: project.productName,
    productId: project.productId,
    state: 'In review'
  });

  const id = response && response.projectVersionId;
  if (!id) {
    throw new Error('Could not create the version record');
  }
  return id;
}
